var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.loadingFinished)?[_c(_vm.layout,{key:"normalLayout",tag:"component",attrs:{"layout-props":_vm.menu,"footer-props":_vm.footer}},[_c('router-view')],1)]:[_c('loading-layout',{key:"loadingComp"})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }